// import Swiper JS
import Swiper from "swiper";
import { EffectFade, Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

// init Swiper:
const swiper = new Swiper('.c-reports-carousel .reports-carousel', {
    modules: [EffectFade, Pagination],
    slidesPerView: 1,
    spaceBetween: 25,
    loop: true,
    grabCursor: true,
    fadeEffect: { crossFade: true },
    effect: "fade",
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    /* TODO: Update animation based on following requested:
    * Quote in right box will animate in typewriter-style upon scroll into view  
    * Slide change animation:
    *   Button and arrows stay between slide but change color
    *   Box stays, but color changes via gradient transition
    *   Quote comes in to box typewriter style, and then text on left
    */
});